var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:[
    'v-cell',
    _vm.overflow && 'v-cell--overflow',
    _vm.hideMobile && 'v-cell--hide-mobile'
  ]},[_c('v-text',{class:[
      'v-cell__text',
      _vm.padding === 'small' && 'p-2',
      _vm.padding === 'medium' && 'p-3',
      _vm.padding === 'large' && 'p-4' ],style:(_vm.cellWidth ? ("width: " + _vm.cellWidth + "px") : ''),attrs:{"title":!_vm.overflow && _vm.title,"bold":_vm.bold}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }